/** Norske etiketter for lead-status og utfall (felles for listetabell, kort og statistikk). */
export const LEAD_STATUS_LABELS: Record<string, string> = {
  open: "Åpen",
  locked: "Låst",
  in_pipe: "I pipe",
  customer: "Kunde",
  parked: "Parkert",
  irrelevant: "Avvist",
};

/** Utfall av en samtale, som på leadkortet. */
export const LEAD_OUTCOME_LABELS: Record<string, string> = {
  no_answer: "Ikke svar",
  not_relevant: "Avvist",
  call_back: "Ring tilbake senere",
  meeting_booked: "Avtalt møte",
  email_sent: "Sendt e-post",
  wrong_number: "Feil nummer",
  email_planned: "Skal sende mail",
};
